import MuiForm from './MuiForm';
export default MuiForm;
